<template>
  <div>
    <div
      class="planetry-table mr-auto mx-auto"
      :style="`font-size: ${font_size};`"
    >
      <table class="table">
        <thead>
        <tr style="font-weight: bold">
          <td class="px-0 py-1" colspan="2" style="background-color: #fff; border: 1px solid #ccc; text-align: center; min-width: 95px;">
            سیاره
          </td>
          <td class="px-0 py-1" colspan="2" style="background-color: #fff; border-bottom: 1px solid #ccc; border-top: 1px solid #ccc; text-align: center;">
            نشان
          </td>
          <td class="px-0 py-1" style="background-color: #fff; border: 1px solid #ccc; text-align: center; min-width: 35px;">
            کاراکا
          </td>
          <td class="px-0" style="background-color: #fff; border: 1px solid #ccc; text-align: center;">
            ناکشاترا
          </td>
          <td class="px-1 py-1" style="background-color: #fff; border: 1px solid #ccc; text-align: center;">
            پادا
          </td>
          <td class="px-0 py-1" style="background-color: #fff; border: 1px solid #ccc; text-align: center;">
            درجه
          </td>
        </tr>
        </thead>
        <tbody>
        <tr style="text-align: center" v-if="lagna">
          <td class="px-0 py-1" style="text-align: center">
            <img :src="'https://www.horastro.co/wp-content/uploads/2022/08/' + lagna['Lg']['rashi_name'] + '.png'" width="30" />
          </td>
          <td class="px-0 py-1" style="background: white; text-align: center; border-bottom: 1px solid #000;">
            <strong>As</strong>
          </td>
          <td class="px-0 py-1" style="background: white; text-align: center; font-weight: bold; border-bottom: 1px solid #000; word-break: keep-all;">
            {{ lagna["Lg"]["rashi_name"] }}
          </td>
          <td class="px-0 py-1" style="background: white; text-align: center; font-weight: bold; border-bottom: 1px solid #000; word-break: keep-all;">
            {{ lagna["Lg"]["rashi"] }}
          </td>
          <td class="px-0 py-1" style="background: white; text-align: center; font-weight: bold; border-bottom: 1px solid #000;">
            -
          </td>
          <td class="px-0 py-1" style="background: white; text-align: center; font-weight: bold; border-bottom: 1px solid #000;">
            {{ lagna["Lg"]["nakshatra"]["name"] }}
          </td>
          <td class="px-0 py-1" style="background: white; text-align: center; font-weight: bold; border-bottom: 1px solid #000;">
            {{ lagna["Lg"]["nakshatra"]["pada"] }}
          </td>
          <td class="px-0 py-1" style="background: white; text-align: center; font-weight: bold; border-bottom: 1px solid #000;">
            {{ formatDegree(lagna["Lg"]) }}
          </td>
        </tr>

        <tr style="text-align: center" v-for="item in planet_order" :key="item" :style="`background-color: ${getPlanetRowBg(grahas[item]['rashiAvastha'], item)}; border-bottom: 1px solid #CCC;`">
          <td class="px-0 py-1" style="text-align: center">
            <img :src="'https://www.horastro.co/wp-content/uploads/2022/08/' + item + '.png'" width="30" />
          </td>
          <td class="px-0 py-1" style="text-align: center; word-break: keep-all">
            <strong>{{ formatPlanetName(item) }}
              <span v-if="grahas[item]['astangata'] != false && grahas[item]['astangata'] != null">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#FBB741" class="bi bi-fire" viewBox="0 0 16 16">
              <path d="M8 16c3.314 0 6-2 6-5.5 0-1.5-.5-4-2.5-6 .25 1.5-1.25 2-1.25 2C11 4 9 .5 6 0c.357 2 .5 4-2 6-1.25 1-2 2.729-2 4.5C2 14 4.686 16 8 16Zm0-1c-1.657 0-3-1-3-2.75 0-.75.25-2 1.25-3C6.125 10 7 10.5 7 10.5c-.375-1.25.5-3.25 2-3.5-.179 1-.25 2 1 3 .625.5 1 1.364 1 2.25C11 14 9.657 15 8 15Z"/>
            </svg>
          </span>
            </strong>
          </td>
          <td class="px-0 py-1" style="text-align: center; word-break: keep-all;">
            {{ grahas[item]["rashi_name"] }}
          </td>
          <td class="px-1 py-1" style="text-align: center; word-break: keep-all;">
            {{ grahas[item]["rashi"] }}
          </td>
          <td class="px-0 py-1" style="text-align: center;">
            {{ grahas[item]["karaka"] }}
          </td>
          <td class="px-0 py-1" style="text-align: center">
            {{ grahas[item]["nakshatra"]["name"] }}
          </td>
          <td class="px-0 py-1" style="text-align: center">
            {{ grahas[item]["nakshatra"]["pada"] }}
          </td>
          <td class="px-0 py-1" style="text-align: center; word-break: keep-all;">
            {{ formatDegree(grahas[item]) }}
          </td>
        </tr>
        </tbody>
      </table>

    </div>
  </div>
</template>

<script>
import HelperLib from "../components/helper";

export default {
  name: "PTableFree",
  components: {
    HelperLib,
  },
  // props: ['grahas', 'lagna', 'box_width', 'is_home_view'],
  props: {
    grahas: {
      type: Object,
    },
    lagna: {
      type: Object,
    },
    box_width: {
      type: Number,
    },
  },
  data() {
    return {
      planet_order: ["Su", "Mo", "Ma", "Me", "Ju", "Ve", "Sa", "Ra", "Ke"],
      font_size: "14px",
    };
  },
  mounted() {
    if (HelperLib.isMobile()) {
      this.font_size = "12px";
    }
    this.createPlanetryTable();
  },
  methods: {
    getPlanetRowBg(text, item) {
      if (item == 'Ra' || item == 'Ke'){
        if ( text != "neecha" || text != "swa"){
          return "white";
        }
        if ( text == "swa"){
          return "rgba(50, 147, 35, 0.15)";
        }
        if ( text == "neecha"){
          return "rgba(181, 32, 32, 0.15)";
        }
      }
      if (text == "neecha") {
        return "rgba(181, 32, 32, 0.15)";
      }
      if (text == "swa") {
        return "rgba(50, 147, 35, 0.15)";
      }
      if (text == "mool") {
        return "rgba(50, 147, 35, 0.15)";
      }
      if (text == "ucha") {
        return "rgba(50, 147, 35, 0.15)";
      } else {
        return "white";
      }
    },
    dignityText(graha, item) {
      // console.log(item)
      if (item == 'Ra' || item == 'Ke'){
        if ( graha["rashiAvastha"] != "neecha" || graha["rashiAvastha"] != "swa"){
          return "-";
        }
      }
      const text = graha["rashiAvastha"];
      if (text == "neecha") {
        return "DB";
      }
      if (text == "swa") {
        return "OH";
      }
      if (text == "mool") {
        return "MT";
      }
      if (text == "ucha") {
        return "EX";
      }
      if (text == "friend") {
        return "F";
      }
      if (text == "enemy") {
        return "E";
      }
      if (text == "neutral") {
        return "N";
      }
    },
    createPlanetryTable() {
      // tbl_order.forEach(element => {
      // });
    },
    formatDegreeLat(graha) {
      return HelperLib.formatDegText(
        graha["latitude_dms"]["deg"],
        graha["latitude_dms"]["min"],
        parseInt(graha["latitude_dms"]["sec"])
      );
    },
    formatSpeed(graha) {
      const speed = graha["speed"];
      const sign = speed >= 0 ? 1 : -1;

      // Convert the speed to a positive value for calculations
      const absSpeed = Math.abs(speed);

      // Calculate the degrees, minutes, and seconds
      const degrees = Math.floor(absSpeed);
      const minutes = Math.floor((absSpeed - degrees) * 60);
      const seconds = ((absSpeed - degrees - minutes / 60) * 3600).toFixed(2);

      // const speed = HelperLib.convertDegreeToDMS(graha['speed'])
      const dmsString = `${HelperLib.paddy(Math.abs(degrees), 2, "0")}°${HelperLib.paddy(
        Math.abs(minutes),
        2,
        "0"
      )}'${HelperLib.paddy(parseInt(Math.abs(seconds)), 2, "0")}"`;

      // Add the sign to the string
      return sign === -1 ? "-" + dmsString : dmsString;
    },
    formatDegreeDec(graha) {
      const dec = HelperLib.convertDegreeToDMS(graha["declination"]);
      return HelperLib.formatDegText(dec["deg"], dec["min"], parseInt(dec["sec"]));
    },
    formatDegree(graha) {
      return HelperLib.formatDegText(
        graha["degree_dms"]["deg"],
        graha["degree_dms"]["min"],
        parseInt(graha["degree_dms"]["sec"])
      );
    },
    formatPlanetName(graha) {
      let name = graha;
      if (this.grahas[graha]["speed"] < 0 && graha !== "Ra" && graha !== "Ke") {
        name = name + "R";
      }
      return name;
    },
  },
};
</script>
<style scoped>
.planetry-table {
  /* background: rgba(255, 253, 231, 0.6); */
  background: #f9f9f9;
}
</style>
